module.exports = __webpack_public_path__ + "static/media/ico_standard_512.899b2e55.png";